
import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 * @param affected Casualty's id
 * @param initial_contact id
 */

export default (payload) =>
  Vue.$http.post(`sinister/send-email/initial-contact-classification/`, payload)
    .then(({ data }) => data)
